
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const AOIPopup= ({ feature }) => (
  <div className="custom-popup">
    <h2 className="popup-title"><span className="value">{feature.properties.name}</span></h2>
    <div className="info-icon">
      <FontAwesomeIcon icon={faInfoCircle} className="icon fa-lg" />
    </div>
  </div>
);

export default AOIPopup;
